type Character = {
  imageUrl: string,
  nameUrl: string,
}

export const characters = {
  "donggeon": {
    imageUrl: require("./assets/characters/donggeon-pic.png"),
    nameUrl: require("./assets/characters/donggeon-name.png"),
  }, 
  "chan": {
    imageUrl: require("./assets/characters/chan-pic.png"),
    nameUrl: require("./assets/characters/chan-name.png"),
  }, 
  "jisu": {
    imageUrl: require("./assets/characters/jisu-pic.png"),
    nameUrl: require("./assets/characters/jisu-name.png"),
  }, 
  "jaeyun": {
    imageUrl: require("./assets/characters/jaeyun-pic.png"),
    nameUrl: require("./assets/characters/jaeyun-name.png"),
  }, 
  "j.you": {
    imageUrl: require("./assets/characters/jyou-pic.png"),
    nameUrl: require("./assets/characters/jyou-name.png"),
  }, 
  "kyungho": {
    imageUrl: require("./assets/characters/kyungho-pic.png"),
    nameUrl: require("./assets/characters/kyungho-name.png"),
  }, 
  "daigo": {
    imageUrl: require("./assets/characters/daigo-pic.png"),
    nameUrl: require("./assets/characters/daigo-name.png"),
  },
  "renta": {
    imageUrl: require("./assets/characters/renta-pic.png"),
    nameUrl: require("./assets/characters/renta-name.png"),
  },  
  "yeojeong": {
    imageUrl: require("./assets/characters/yeojeong-pic.png"),
    nameUrl: require("./assets/characters/yeojeong-name.png"),
  }, 
}

export default Character;